<template>
  <span :class="$style.tooltip"
        ref="tooltip"
        @click="toggleTooltip">
    <span class="custom-tooltip"
          :style="{width: width}"
          :class="[{[$style.active] : showTooltip }, $style.tooltipText, getTooltipStyle]">
      <span :class="$style.tooltipHeader">
        <slot name="tooltipHeader" />
      </span>
      <span :class="$style.tooltipMainText">
        <slot name="tooltipText" />
      </span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
    down: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      showTooltip: false,
      necessaryTooltipOffset: 80,
      tooltipTextWidth: 444,
      tooltipOffset: 0,
    };
  },
  methods: {
    toggleTooltip(e) {
      e.preventDefault();
      this.showTooltip = !this.showTooltip;
    },
    setTooltipOffset() {
      if (this.$refs.tooltip) {
        const windowWidth = window.innerWidth;
        const offsetLeft = this.$refs.tooltip.getBoundingClientRect().left;
        const tooltipWidth = this.$refs.tooltip.clientWidth;
        const rightOffset = windowWidth - offsetLeft - tooltipWidth;

        this.tooltipOffset = rightOffset - this.tooltipTextWidth - this.necessaryTooltipOffset;
      }
    },
  },
  computed: {
    getTooltipOffset() {
      return this.tooltipOffset;
    },
    getTooltipStyle() {
      if (this.centered) {
        return this.$style.tooltipCenter;
      }
      if (this.right) {
        return this.$style.tooltipRight;
      }
      if (this.down || this.getTooltipOffset < 0) {
        return this.$style.tooltipDown;
      }
      return this.$style.tooltipRight;
    },
  },
  updated() {
    this.setTooltipOffset();
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.setTooltipOffset();
      });
    });
  },
  created() {
    document.addEventListener('click', (e) => {
      if (e.target !== this.$refs.tooltip) {
        this.showTooltip = false;
      }
    });
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.tooltip {
  display: inline-block;
  margin-left: 4px;
  width: 18px;
  height: 18px;
  background-image: url('@/assets/img/ic_info.png');
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  white-space: normal;
  cursor: pointer;

  .tooltipText {
    position: absolute;
    min-width: 444px;
    color: $white-color;
    background-color: $tooltip-background-color;
    padding: 9px 20px;
    border-radius: 4px;
    font-style: normal;
    display: none;
    opacity: 0;
    z-index: 10;
    transition: opacity 0.25s ease-in-out;

    &.tooltipDown {
      right: 0;
      top: calc(100% + 10px);
      min-width: 300px;
    }

    &.tooltipRight {
      top: 100%;
      left: 100%;
    }

    &.tooltipCenter {
      left: calc(50% - 150px);
      top: calc(100% + 10px);
      min-width: 300px;
    }

    &.active {
      display: block;
      opacity: 1;
    }

    .tooltipHeader {
      display: block;
      font-family: $title-font;
      font-size: 1.5rem;
      line-height: 2.4rem;
      font-weight: 700;
      margin-bottom: 4px;
    }

    .tooltipMainText {
      display: block;
      font-family: $main-font;
      font-size: 1.4rem;
      line-height: 1.9rem;
      font-weight: 400;
    }
  }
}
</style>
